var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "upgrade-needed",
        "show-footer": false,
        "show-title": false,
        design: "v3",
      },
      on: { cancel: _vm.cancel },
    },
    [
      _vm.creditCardNeededModal
        ? _c("CreditCardNeeded", {
            on: {
              close: function ($event) {
                _vm.creditCardNeededModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "upgrade-needed-content" }, [
        _c(
          "div",
          { staticClass: "upgrade-needed-content-title" },
          [
            _c("UpgradeIconSvg"),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("message.upgradePackageTitle")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-needed-content-description" },
          [
            _vm.descriptions[_vm.upgradeDetail.name]
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.descriptions[_vm.upgradeDetail.name]) +
                      "\n            "
                  ),
                ]
              : [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.moreFeaturesDesc")) +
                      "\n            "
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _vm.plan === "tasks"
          ? _c(
              "div",
              { staticClass: "upgrade-needed-content-info info-tasks" },
              [
                _c("a-icon", {
                  staticClass: "info-icon",
                  attrs: { type: "info-circle" },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "Çöp sepetinizi kontrol ediniz. Çöp sepetinden silmediğiniz iş akışınız varsa onlar da limite dahildir. Önce çöp kutusunu temizleyiniz."
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.plan === "form"
          ? _c(
              "div",
              { staticClass: "upgrade-needed-content-info info-form" },
              [
                _c("a-icon", {
                  staticClass: "info-icon",
                  attrs: { type: "info-circle" },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "Çöp sepetinizi kontrol ediniz. Çöp sepetinden silmediğiniz formlarınız varsa onlar da limite dahildir. Önce çöp kutusunu temizleyiniz."
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.plan === "customer-tables"
          ? _c(
              "div",
              { staticClass: "upgrade-needed-content-info info-tables" },
              [
                _c("a-icon", {
                  staticClass: "info-icon",
                  attrs: { type: "info-circle" },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "Çöp sepetinizi kontrol ediniz. Çöp sepetinden silmediğiniz tablolarınız varsa onlar da limite dahildir. Önce çöp kutusunu temizleyiniz."
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-needed-content-content" },
          [_c("UpgradeSVG")],
          1
        ),
        _vm._v(" "),
        _vm.nextPlan
          ? _c("div", { staticClass: "upgrade-needed-content-suggestion" }, [
              _c(
                "div",
                {
                  staticClass: "suggestion-columns",
                  class: { single: !_vm.currentPlan },
                },
                [
                  _vm.currentPlan
                    ? _c("div", { staticClass: "col current" }, [
                        _c("div", { staticClass: "suggestion-badge" }, [
                          _vm._v("Mevcut Plan"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "suggestion-title" }, [
                          _vm._v(
                            _vm._s(_vm.currentPlan.title) +
                              " " +
                              _vm._s(_vm.currentPlan.altTitle)
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.currentSubscriptionDetailCount &&
                        _vm.detailUnitLabel
                          ? _c("div", { staticClass: "suggestion-metrics" }, [
                              _c("div", { staticClass: "metric" }, [
                                _c("span", { staticClass: "metric-count" }, [
                                  _vm._v(
                                    _vm._s(_vm.currentSubscriptionDetailCount)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "metric-unit" }, [
                                  _vm._v(_vm._s(_vm.detailUnitLabel)),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentPlan
                    ? _c("div", { staticClass: "suggestion-arrow" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("arrow_forward"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col next" }, [
                    _c("div", { staticClass: "suggestion-badge" }, [
                      _vm._v("Önerilen Plan"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "suggestion-title" }, [
                      _vm._v(
                        _vm._s(_vm.nextPlan.title) +
                          " " +
                          _vm._s(_vm.nextPlan.altTitle)
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.nextSubscription &&
                    _vm.nextSubscription.details &&
                    _vm.detailUnitLabel
                      ? _c("div", { staticClass: "suggestion-metrics" }, [
                          _c("div", { staticClass: "metric" }, [
                            _c("span", { staticClass: "metric-count" }, [
                              _vm._v(_vm._s(_vm.nextSubscriptionDetailCount)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "metric-unit" }, [
                              _vm._v(_vm._s(_vm.detailUnitLabel)),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-needed-content-footer" },
          [
            _vm.nextSubscription
              ? [
                  _c(
                    "SupsisButton",
                    {
                      attrs: {
                        primary: "",
                        disabled: _vm.isUpgrading,
                        icon: _vm.isUpgrading ? "autorenew" : "",
                        "class-names": _vm.isUpgrading ? "loading" : "",
                      },
                      on: { click: _vm.upgrade },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.isTrialMode
                              ? "Ücretsiz Hemen Yükselt"
                              : "Hemen Yükselt"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    { attrs: { secondary: "" }, on: { click: _vm.goToPlans } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.isTrialMode
                              ? "Ücretsiz Planları Görüntüle"
                              : "Planları Görüntüle"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "SupsisButton",
                    { attrs: { primary: "" }, on: { click: _vm.goToPlans } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.isTrialMode
                              ? "Ücretsiz Planları İncele"
                              : "Planları İncele"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }